/**
 * Build a nested folder tree from the flat slash-delimited paths returned by
 * the /tree endpoint (e.g. "/My Drive", "/My Drive/Reports/2024"). Intermediate
 * folders are synthesized even when they are not themselves keys in the input.
 */
export function buildFolderTree(paths) {
    const roots = [];
    const index = new Map();
    for (const full of paths) {
        const segments = full.split("/").filter(Boolean);
        let cur = "";
        let siblings = roots;
        for (const seg of segments) {
            cur = `${cur}/${seg}`;
            let node = index.get(cur);
            if (!node) {
                node = { name: seg, path: cur, children: [] };
                index.set(cur, node);
                siblings.push(node);
            }
            siblings = node.children;
        }
    }
    const sortRec = (nodes) => {
        nodes.sort((a, b) => a.name.localeCompare(b.name));
        nodes.forEach((n) => sortRec(n.children));
    };
    sortRec(roots);
    return roots;
}
